import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import jwtDecode from "jwt-decode";
import { Document, Page } from "react-pdf";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.worker.min.mjs";

const Statement = () => {
  const { monthYear } = useParams();
  const [years, setYears] = useState([]);
  const [months, setMonths] = useState([]);
  const [selectedYear, setSelectedYear] = useState(monthYear ? monthYear.split("-")[1] : "");
  const [selectedMonth, setSelectedMonth] = useState(
    monthYear ? `${monthYear.split("-")[0].padStart(2, "0")}` : ""
  );
  const [filesData, setFilesData] = useState(null);
  const [currentPdf, setCurrentPdf] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [docWidth, setDocWidth] = useState(Math.min(window.innerWidth * 0.85, 900));

  useEffect(() => {
    const handleResize = () => setDocWidth(Math.min(window.innerWidth * 0.85, 900));
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (token) {
      const decoded = jwtDecode(token);
      console.debug("Viewing statements for", decoded.user);
    }
  }, []);

  useEffect(() => {
    const fetchStatements = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASEURL}/statements/${localStorage.getItem("currentUser")}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const data = await response.json();
        const statementsByYear = data?.statements || {};

        setFilesData(statementsByYear);

        const availableYears = Object.keys(statementsByYear).sort((a, b) => b - a);
        setYears(availableYears);

        const storedSelectionRaw = localStorage.getItem("statementSelection");
        let storedSelection = null;
        if (storedSelectionRaw) {
          try {
            storedSelection = JSON.parse(storedSelectionRaw);
          } catch (error) {
            storedSelection = null;
          }
          localStorage.removeItem("statementSelection");
        }

        if (storedSelection && availableYears.includes(storedSelection.year)) {
          setSelectedYear(storedSelection.year);
          const availableMonths = Object.keys(statementsByYear[storedSelection.year] || {}).sort((a, b) => b - a);
          setMonths(availableMonths);
          if (availableMonths.includes(storedSelection.month)) {
            setSelectedMonth(storedSelection.month);
          }
        } else if (!selectedYear && availableYears.length) {
          setSelectedYear(availableYears[0]);
        }
      } catch (error) {
        console.error("Error fetching statements:", error);
        toast.error("Unable to load statements");
      }
    };

    fetchStatements();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (filesData && selectedYear && filesData[selectedYear]) {
      const availableMonths = Object.keys(filesData[selectedYear]).sort((a, b) => b - a);
      setMonths(availableMonths);

      if (!selectedMonth && availableMonths.length) {
        setSelectedMonth(availableMonths[0]);
      }
    }
  }, [filesData, selectedYear, selectedMonth]);

  useEffect(() => {
    if (
      filesData &&
      selectedYear &&
      selectedMonth &&
      filesData[selectedYear] &&
      filesData[selectedYear][selectedMonth]
    ) {
      const file = filesData[selectedYear][selectedMonth][0];
      const relativePath = file?.relativePath || file?.fileName;
      setCurrentPdf(
        relativePath
          ? `${process.env.REACT_APP_API_BASEURL}/assets/documents/statements/${relativePath}`
          : null
      );
    } else {
      setCurrentPdf(null);
    }
  }, [filesData, selectedYear, selectedMonth]);

  return (
    <div className="customer-layout">
      <Navbar />
      <main className="customer-main">
        <section className="statement-filter card">
          <header className="card-header card-header--stacked">
            <h1 className="page-hero__title">Account Statement</h1>
          </header>
          <div className="statement-filter__controls">
            <label>
              <span>Year</span>
              <select
                value={selectedYear}
                onChange={(event) => {
                  setSelectedYear(event.target.value);
                  setSelectedMonth("");
                }}
              >
                <option value="">Select year</option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </label>
            <label>
              <span>Month</span>
              <select
                value={selectedMonth}
                onChange={(event) => setSelectedMonth(event.target.value)}
                disabled={!selectedYear}
              >
                <option value="">Select month</option>
                {months.map((month) => {
                  const date = new Date(`${selectedYear}-${month}-01`);
                  return (
                    <option key={month} value={month}>
                      {date.toLocaleString("default", { month: "long" })}
                    </option>
                  );
                })}
              </select>
            </label>
          </div>
        </section>

        <section className="documents-viewer card">
          {currentPdf ? (
            <Document
              file={currentPdf}
              onLoadSuccess={({ numPages: nextNumPages }) => setNumPages(nextNumPages)}
            >
              {Array.from({ length: numPages || 0 }, (_, index) => (
                <Page key={`page_${index + 1}`} pageNumber={index + 1} width={docWidth} />
              ))}
            </Document>
          ) : (
            <div className="notes-empty">No statement selected.</div>
          )}
        </section>
      </main>
    </div>
  );
};

export default Statement;
